import React from 'react';

import { FlexBoxColumn } from '@ecp/common/src/layouts/flex/styled';
import { Spacing } from '@ecp/common/src/layouts/Spacing';

import {
  Container,
  InfoTextBox,
  SkypassFooterSubNoticeContainer,
  TextBold,
} from '@ecp/mo/sites/skypass/styles/footer/SkypassFooterNoticeStyles';

export default function SkypassFooterNotice() {
  return (
    <Container>
      <FlexBoxColumn align-items={'flex-start'}>
        <Spacing top={'30px'} />
        <InfoTextBox size={'18px'} weight={'500'} height={'28px'}>
          알아두세요
        </InfoTextBox>
        <Spacing top={'4px'} />
        <SkypassFooterSubNoticeContainer>
          <InfoTextBox size={'11px'}>
            <TextBold>•</TextBold>대한항공 홈페이지 회원 가입 및 로그인 후 이용 가능합니다.
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>•</TextBold>본인의 보유 마일리지만 사용할 수 있으며, 가족합산은 불가합니다.
          </InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>•</TextBold>상품 구매취소나 환불 시, 유효기간이 지난 마일리지는 소멸되어
          </InfoTextBox>
          <InfoTextBox size={'11px'}>     환급되지 않습니다.</InfoTextBox>
          <InfoTextBox size={'11px'}>
            <TextBold>•</TextBold>자세한 내용은 상품 상세 페이지를 참고해주세요.
          </InfoTextBox>
        </SkypassFooterSubNoticeContainer>
      </FlexBoxColumn>
    </Container>
  );
}
